// calculateMonthlyBudget.js

export function countOccurrencesThisMonth(startDate, intervalDays, today = new Date()) {
  const [year, month, day] = startDate.split("-");
  const cursor = new Date(year, month - 1, day);
  cursor.setHours(0, 0, 0, 0);

  const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
  const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  monthEnd.setHours(23, 59, 59, 999);

  let count = 0;

  while (cursor < monthStart) {
    cursor.setDate(cursor.getDate() + intervalDays);
  }

  while (cursor <= monthEnd) {
    count++;
    cursor.setDate(cursor.getDate() + intervalDays);
  }

  return count;
}

export function calculateMonthlyBudget(sub, today = new Date(), raw = false) {
  const { amount, frequency, normalize, payDate, customAmounts } = sub;

  if (!amount || isNaN(amount)) return raw ? 0 : "$0.00";

  const amountFloat = parseFloat(amount);
  const year = today.getFullYear();
  const month = today.getMonth();

  if (frequency === "custom") {
    const customAmount = parseFloat(customAmounts?.[month] || 0);
    return raw
      ? customAmount
      : `$${customAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  if (!normalize && payDate) {
    let periodLength = 30;
    switch (frequency) {
      case "weekly":
        periodLength = 7;
        break;
      case "bi-weekly":
        periodLength = 14;
        break;
      case "quarterly":
        periodLength = 91;
        break;
      case "annual":
        periodLength = 365;
        break;
      default:
        periodLength = 30;
    }

    const count = countOccurrencesThisMonth(payDate, periodLength, today);
    const monthly = amountFloat * count;
    return raw
      ? monthly
      : `$${monthly.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  if (frequency === "twice-monthly") {
    const monthly = amountFloat * 2;
    return raw
      ? monthly
      : `$${monthly.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  if (normalize) {
    let multiplier = 1;
    switch (frequency) {
      case "weekly":
        multiplier = 4.33;
        break;
      case "bi-weekly":
        multiplier = 2.17;
        break;
      case "quarterly":
        multiplier = 1 / 3;
        break;
      case "annual":
        multiplier = 1 / 12;
        break;
      default:
        multiplier = 1;
    }
    const monthly = amountFloat * multiplier;
    return raw
      ? monthly
      : `$${monthly.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  // Default: plain monthly, no extra adjustments
  return raw
    ? amountFloat
    : `$${amountFloat.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}